import { render, staticRenderFns } from "./FoodClassUpdate.vue?vue&type=template&id=b6c3eb06&"
import script from "./FoodClassUpdate.vue?vue&type=script&lang=js&"
export * from "./FoodClassUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FoodClassUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports